import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SHOW_TAB,
  FETCH_VOLUNTEER_TIME_OFF_SUMMARY_SUCCESS,
  FETCH_VOLUNTEER_TIME_OFF_SUMMARY_FAILED,
  FETCH_VOLUNTEER_TIME_OFFS_SUCCESS,
  FETCH_VOLUNTEER_TIME_OFFS_FAILED,
  IMPERSONATE,
  IMPERSONATE_SUCCESS,
  IMPERSONATE_FAILED,
} from './constants';

export const initAction = (id: string) => ({ type: INIT, id });
export const initSuccessAction = () => ({ type: INIT_SUCCESS });
export const initFailedAction = (error: Error, errorCode?: string | number) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const showTabAction = (tab: string) => ({
  type: SHOW_TAB,
  tab,
});

export const fetchVolunteerTimeOffsSuccessAction = () => ({
  type: FETCH_VOLUNTEER_TIME_OFFS_SUCCESS,
});

export const fetchVolunteerTimeOffsFailedAction = (error: Error) => ({
  type: FETCH_VOLUNTEER_TIME_OFFS_FAILED,
  error,
});

export const fetchVolunteerTimeOffSummarySuccessAction = () => ({
  type: FETCH_VOLUNTEER_TIME_OFF_SUMMARY_SUCCESS,
});

export const fetchVolunteerTimeOffSummaryFailedAction = (error: Error) => ({
  type: FETCH_VOLUNTEER_TIME_OFF_SUMMARY_FAILED,
  error,
});

export const impersonateAction = (userId: string, impersonationReason: string) => ({
  type: IMPERSONATE,
  userId,
  impersonationReason,
});

export const impersonateSuccessAction = () => ({
  type: IMPERSONATE_SUCCESS,
});

export const impersonateFailedAction = (error: Error) => ({
  type: IMPERSONATE_FAILED,
  error,
});
